export default __webpack_public_path__ + "static/sprite-b4d4090f9ab173635d8d6ffda46109a1.svg";